<template>
  <div>
    <h4>Solicitações de meia entrada</h4>
    <ConcessionHighlights class="mb-4" />
    <v-alert v-if="error" type="error">
      {{ error }}
    </v-alert>
    <v-alert v-if="loading" type="info">
      Carregando solicitações de meia entrada...
    </v-alert>
    <template v-else>
      <v-data-table
        v-if="concessionRequests.length > 0"
        :headers="headers"
        :items="concessionRequests"
        sort-by="createdAt"
        sort-desc
      >
        <template v-slot:item.type="{ item }">
          <v-chip small label>
            {{ definitions.types[item.type].name }}
          </v-chip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            :color="definitions.status[item.status].color"
            text-color="white"
            small
            label
          >
            {{ definitions.status[item.status].text }}
          </v-chip>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                {{ [item.createdAt] | dateDiff }}
              </span>
            </template>
            <span>{{ item.createdAt | date }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            color="primary"
            @click="viewConcessionRequest(item.id)"
            depressed
            small
          >
            Ver
          </v-btn>
        </template>
      </v-data-table>
      <v-card
        v-else
        outlined
        class="pa-4 d-flex flex-column align-center justify-center"
      >
        <v-icon size="80">mdi-file-search-outline</v-icon>
        <h5 class="mt-4">
          Todas as solicitações de meia entrada foram resolvidas
        </h5>
        <p class="mt-2">Nenhuma solicitação de meia entrada encontrada</p>
      </v-card>
    </template>
    <ConcessionRequestModal @refresh="refresh" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import definitions from "@/definitions/ConcessionRequest.json";
import CONCESSION_REQUESTS from "@/services/admin/concessionRequest";
import ConcessionRequestModal from "@/components/admin/concessionRequest/ConcessionRequestModal.vue";
import ConcessionHighlights from "@/components/admin/concessionRequest/ConcessionHighlights.vue";
export default {
  name: "ConcessionRequest",
  components: {
    ConcessionRequestModal,
    ConcessionHighlights,
  },
  data() {
    return {
      definitions,
      error: false,
      loading: false,
      concessionRequests: [],
      headers: [
        {
          text: "Usuário",
          value: "User.name",
        },
        {
          text: "Tipo",
          value: "type",
        },
        {
          text: "Status",
          value: "status",
        },
        {
          text: "Solicitado há",
          value: "createdAt",
          align: "center",
        },
        {
          text: "Ações",
          value: "actions",
        },
      ],
    };
  },
  methods: {
    refresh() {
      this.$emit("refresh");
      this.$root.$emit("refreshConcessionRequests");
      console.log("Emitting refresh event to child components and on root");
      this.getConcessionRequests();
    },
    async getConcessionRequests() {
      try {
        this.loading = true;
        const response = await CONCESSION_REQUESTS.getAll();
        this.concessionRequests = response.concessionRequests;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    viewConcessionRequest(id) {
      this.$emit("viewConcessionRequest", id);
    },
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
  },
  watch: {
    "selectedCompany.id"() {
      this.concessionRequests = [];
      this.getConcessionRequests();
      this.$emit("refresh");
    },
  },
  mounted() {
    this.getConcessionRequests();
  },
};
</script>
